import i18n from 'src/i18n';
import Tables from 'src/class/Tables';

const configTable = () => {
  const Table = { ...Tables.Table };

  Table.tableColumns = [
    {
      prop: 'header_date',
      label: i18n.t('common_words.date'),
      minWidth: 100,
      sortable: true,
    },
    {
      prop: 'worker.code',
      label: 'Código Trabajador',
      sortable: true,
      minWidth: 100,
      align: 'center',
    },
    {
      prop: 'worker.name',
      label: i18n.t('labor.worker'),
      minWidth: 180,
      sortable: true,
    },
    {
      prop: 'farm.name',
      label: i18n.t('common_words.farm'),
      minWidth: 150,
      sortable: true,
    },
  ];

  const TableDetails = { ...Tables.Table };

  TableDetails.tableColumns = [
    {
      prop: 'detail_date',
      label: i18n.t('common_words.date'),
      minWidth: 100,
      sortable: true,
    },
    {
      prop: 'activity.code',
      label: 'Código Actividad',
      minWidth: 100,
      align: 'center',
      sortable: true,
    },
    {
      prop: 'activity.name',
      label: i18n.t('common_words.activity'),
      minWidth: 180,
      sortable: true,
    },
    {
      prop: 'lot.name',
      label: i18n.t('common_words.allotment'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'total_duration',
      label: 'Duración de actividad',
      minWidth: 120,
      sortable: true,
      align: 'center',
    },
  ];

  const SearchDetails = {
    pagedDataDetails() {
      return this.tableDataDetails.slice(this.fromDetails, this.toDetails);
    },

    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedDataDetails() {
      let result = this.tableDataDetails;
      if (this.searchQueryDetails !== '') {
        result = this.fuseSearchDetails.search(
          '=' + this.searchQueryDetails + ''
        );
      }
      this.paginationDetails.total = result.length;

      if (this.$refs.cardfooterdetail) {
        this.$refs.cardfooterdetail.totals = this.paginationDetails.total;
      }

      return result.slice(this.fromDetails, this.toDetails);
    },

    toDetails() {
      let highBound = this.fromDetails + this.paginationDetails.perPage;
      if (this.totalDetails < highBound) {
        highBound = this.totalDetails;
      }

      if (this.$refs.cardfooterdetail) {
        this.$refs.cardfooterdetail.tos = highBound;
      }

      return highBound;
    },

    fromDetails() {
      let from =
        this.paginationDetails.perPage *
        (this.paginationDetails.currentPage - 1);
      if (this.$refs.cardfooterdetail) {
        this.$refs.cardfooterdetail.froms = from;
      }

      return from;
    },

    totalDetails() {
      if (this.$refs.cardfooterdetail) {
        this.$refs.cardfooterdetail.totals = this.paginationDetails.total;
      }

      return this.paginationDetails.total;
    },
  };

  return { Table, TableDetails, SearchDetails };
};

export default configTable;
